const mutation = {
  // 设置数量
  set_digits: (state, obj) => {
    state.unitPriceDigits = obj.unitPriceDigits
    state.totalPriceDigits = obj.totalPriceDigits
    state.numberDigits = obj.numberDigits
    state.isFetching = obj.isFetching || true
  }
}
export default mutation
